import { formatSaveDate } from 'reducers/TimeReducer';
import { ISO_UTC_REGEX } from '../constants/regex';

const isConvertibleDate = (value) =>
  value instanceof Date || (typeof value === 'string' && ISO_UTC_REGEX.test(value));

const transformDatesDeep = (value) => {
  if (isConvertibleDate(value)) {
    return formatSaveDate(value);
  }
  if (Array.isArray(value)) {
    return value.map(transformDatesDeep);
  }
  if (value && typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value).map(([key, val]) => [key, transformDatesDeep(val)])
    );
  }
  return value;
};

export const transformDatesHook = (context) => {
  if (context.data) {
    context.data = transformDatesDeep(context.data);
  }
  return context;
};
